import React, { Component } from "react";
// import $ from "jquery";

import css from "./SisPagination.module.scss";

// 부트스트랩
import { Table, Pagination } from "react-bootstrap";
// import "bootstrap/dist/css/bootstrap.min.css";

class SisPagination extends Component {
	constructor(props) {
		super(props);

		this.state = {
			curPage: 1,
			lastPage: props.viewCount ? Math.ceil(props.totalCount / props.viewCount) : Math.ceil(props.totalCount / 15),
			viewCount: props.viewCount ? props.viewCount : 15,
		};
	}

	static getDerivedStateFromProps = (props, state) => {
		return props;
	};

	static getDerivedStateFromProps = (props, state) => {
		return props;
	};

	// 처음 페이지
	firstpage = () => {
		if (this.props.onClick) {
			this.props.onClick(1);
		}

		this.setState({
			curPage: 1,
		});
	};

	// 이전 페이지
	prevPage = () => {
		if (this.state.curPage > 1) {
			if (this.props.onClick) {
				this.props.onClick(this.state.curPage - 1);
			}

			this.setState({
				curPage: this.state.curPage - 1,
			});
		}
	};

	// 다음 페이지
	nextPage = () => {
		if (this.state.curPage < this.state.lastPage) {
			if (this.props.onClick) {
				this.props.onClick(this.state.curPage + 1);
			}

			this.setState({
				curPage: this.state.curPage + 1,
			});
		}
	};

	// 마지막 페이지
	lastPage = () => {
		if (this.props.onClick) {
			this.props.onClick(this.state.lastPage);
		}

		this.setState({
			curPage: this.state.lastPage,
		});
	};

	pageClick = (evt) => {
		if (this.props.onClick) {
			this.props.onClick(parseInt(evt.target.text));
		}

		this.setState({
			curPage: parseInt(evt.target.text),
		});
	};

	render() {
		// // console.log(this.state);
		const { curPage, viewCount, totalCount } = this.state;

		let pagination = null;

		// 페이징 관련
		const pageCount = 3; // 페이징 개수
		const lastPage = Math.ceil(totalCount / viewCount);

		const startPage = curPage % pageCount === 0 ? curPage - pageCount + 1 : curPage - (curPage % pageCount) + 1;
		const endPage = startPage + pageCount - 1;

		if (totalCount > 0) {
			let pages = [];
			for (let i = startPage; i <= endPage; i++) {
				if (i > lastPage) break;
				if (i === curPage)
					pages.push(
						<a href={`#${i}`} className={`${css.page} ${css.active}`} key={i}>
							{i}
						</a>
					);
				else
					pages.push(
						<a href={`#${i}`} className={css.page} key={i} onClick={this.pageClick}>
							{i}
						</a>
					);
			}

			pagination = (
				<div className={css.sisPagination}>
					<a href={`#first`} className={css.firstPage} onClick={this.firstpage}>
						{"<<"}
					</a>
					<a href={`#prev`} className={css.prevPage} onClick={this.prevPage}>
						{"<"}
					</a>
					{pages}
					<a href={`#next`} className={css.nextPage} onClick={this.nextPage}>
						{">"}
					</a>
					<a href={`#last`} className={css.lastPage} onClick={this.lastPage}>
						{">>"}
					</a>
				</div>
			);
		}

		return <div className={css.sisPaginationWrap}>{pagination}</div>;
	}
}

export default SisPagination;
